/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1NotificationMobileAppQueryResponse,
  GetApiV1NotificationMobileAppQueryParams,
  GetApiV1NotificationMobileApp401,
  GetApiV1NotificationMobileApp500,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileApp.ts";

function getGetApiV1NotificationMobileAppUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/notification/mobile-app` as const,
  };
  return res;
}

/**
 * @description Suporta filtros por tipo de template, criado por, período de agendamento e busca por texto (título, tipo de template, código ou nome da turma). **(Requer Authorization para autenticação)**
 * @summary Retorna a grid paginada de notificações (Requer Authorization para autenticação)
 * {@link /api/v1/notification/mobile-app}
 */
export async function getApiV1NotificationMobileApp(
  params?: GetApiV1NotificationMobileAppQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1NotificationMobileAppQueryResponse,
    ResponseErrorConfig<
      GetApiV1NotificationMobileApp401 | GetApiV1NotificationMobileApp500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1NotificationMobileAppUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
